/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import {
  get as _get,
  find as _find,
  includes as _includes,
  toUpper as _toUpper,
} from "lodash";
import {
  Box,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  TextField,
  Tooltip,
  Button,
} from "@material-ui/core";
import DoneIcon from "@material-ui/icons/CheckCircleOutlineRounded";
import ClearIcon from "@material-ui/icons/Clear";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmptyRounded";
import ThumbUpIcon from "@material-ui/icons/CheckCircle";
import ThumbDownIcon from "@material-ui/icons/Cancel";
import DescriptionIcon from "@material-ui/icons/Description";
import EmojiPeopleIcon from "@material-ui/icons/EmojiPeople";

import useStyles from "./CompaniesList.styles";
import { connect, useSelector } from "react-redux";
import { createStructuredSelector } from "reselect";

import rh from "../../images/rh.png";
import rbm from "../../images/rbm.png";
import bma from "../../images/bma.png";
import bma24 from "../../images/bma247.png";
import hag from "../../images/hag.png";
import giroflex from "../../images/giroflex.png";
import offecct from "../../images/offecct.png";

import NoTick from "../../images/icons/no-tick-new.png";
import SingleTick from "../../images/icons/single-tick-new.png";
import DoubleTick from "../../images/icons/double-tick-new.png";
import ContractIcon from "../../images/icons/contract.png";
import SignatueIcon from "../../images/icons/signature-taupe.png";
import SandclockIcon from "../../images/icons/sandclock-green.png";
import EnvelopeIcon from "../../images/icons/envelope.png";
import HandshakeIcon from "../../images/icons/handshake.png";

import {
  retrieveCompanies,
  selectCompany,
} from "../../redux/company/company.actions";

import {
  selectCompaniesCollection,
  selectIsCompaniesCollectionFetching,
} from "../../redux/company/company.selector";

const CompaniesList = ({
  history,
  isCompaniesCollectionFetching,
  companiesList,
  retrieveCompanies,
  selectCompany,
}) => {
  const user = useSelector((state) => state.user);
  const [companySearchText, setCompanySearchText] = React.useState("");
  const classes = useStyles();
  const [companiesDisplayList, setCompaniesDisplayList] =
    React.useState(companiesList);
  React.useEffect(() => {
    retrieveCompanies();
  }, []);

  React.useEffect(() => {
    const brands = ["rh", "rbm", "bma", "bma24", "hag", "giroflex", "offecct"];
    companiesList.map((c) => {
      let _brands = [];
      brands.map((b) => {
        let _bo = _find(c.brands, { brand_name: b });
        if (_bo) _brands.push(_bo);
      });
      c.brands = _brands;
    });
    setCompaniesDisplayList(companiesList);
  }, [companiesList]);

  React.useEffect(() => {
    if (companySearchText.length > 2) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      let _companiesDisplayList = [];
      companiesList.map((c) => {
        if (
          _includes(_toUpper(c.name), _toUpper(companySearchText)) ||
          _includes(
            _toUpper(c.main_sales_lead_first_name),
            _toUpper(companySearchText)
          ) ||
          _includes(
            _toUpper(c.main_sales_lead_last_name),
            _toUpper(companySearchText)
          ) ||
          _includes(
            _toUpper(c.trader_contact_first_name),
            _toUpper(companySearchText)
          ) ||
          _includes(
            _toUpper(c.trader_contact_last_name),
            _toUpper(companySearchText)
          ) ||
          _includes(c.company_customer_no, companySearchText)
        )
          _companiesDisplayList.push(c);
      });
      setCompaniesDisplayList(_companiesDisplayList);
    } else {
      setCompaniesDisplayList(companiesList);
    }
  }, [companySearchText, companiesList]);

  const handleCompanySearchTextChange = (event) => {
    setCompanySearchText(event.target.value);
  };

  const getBrandStatusIcon = (status) => {
    let iconComponent = <div></div>;
    switch (status) {
      case "initial":
        iconComponent = <img src={NoTick} className={classes.statusIcon} />;
        break;
      case "negotiated":
        iconComponent = <img src={SingleTick} className={classes.statusIcon} />;
        break;
      case "rejected":
        iconComponent = <ClearIcon className={classes.statusIcon} />;
        break;
      case "confirmed":
        iconComponent = <img src={DoubleTick} className={classes.statusIcon} />;
        break;
      default:
        iconComponent = <HourglassEmptyIcon className={classes.statusIcon} />;
    }
    return iconComponent;
  };

  const getContractStatusIcon = (status) => {
    let iconComponent = <div></div>;
    switch (status) {
      case "negotiating":
        iconComponent = (
          <img src={SandclockIcon} className={classes.contractStatusIcon} />
        );
        break;
      case "awaiting_client_sig":
        iconComponent = (
          <img src={EnvelopeIcon} className={classes.contractStatusIcon} />
        );
        break;
      case "rejected":
        iconComponent = <ClearIcon className={classes.contractStatusIcon} />;
        break;
      case "closed":
        iconComponent = (
          <img src={HandshakeIcon} className={classes.contractStatusIcon} />
        );
        break;
      default:
        iconComponent = (
          <img src={SandclockIcon} className={classes.contractStatusIcon} />
        );
    }
    return iconComponent;
  };

  const getStatusDisplayValue = (status) => {
    let _o = "";
    switch (status) {
      case "initial":
        _o = "Verhandeln";
        break;
      case "negotiated":
        _o = "Ausgehandelt";
        break;
      case "confirmed":
        _o = "Bestätigt";
        break;
      case "rejected":
        _o = "Abgelehnt";
        break;

      case "negotiating":
        _o = "Verhandeln";
        break;

      case "awaiting_client_sig":
        _o = "Vertrag versendet an Händler";
        break;
      case "closed":
        _o = "Vertrag beiderseitig unterschrieben ";
        break;
      default:
        break;
    }
    return _o;
  };
  const getBrandLogoElement = (brandName) => {
    if (brandName === "rh") {
      return <img src={rh} className={classes.tabLogos} />;
    } else if (brandName === "rbm") {
      return <img src={rbm} className={classes.tabLogos} />;
    } else if (brandName === "bma") {
      return <img src={bma} className={classes.tabLogos} />;
    } else if (brandName === "bma24") {
      return <img src={bma24} className={classes.tabLogos} />;
    } else if (brandName === "hag") {
      return <img src={hag} className={classes.tabLogos} />;
    } else if (brandName === "giroflex") {
      return <img src={giroflex} className={classes.tabLogos} />;
    } else if (brandName === "offecct") {
      return <img src={offecct} className={classes.tabLogos} />;
    }
  };
  return (
    <Box>
      <div className={classes.tableTitleHeader}>
        <Typography variant="h6" className={classes.tableTitle}>
          Kundenliste
        </Typography>
        <div>
          <TextField
            variant="outlined"
            label="Suche"
            value={companySearchText}
            onChange={handleCompanySearchTextChange}
          />
          <Button
            onClick={() => {
              selectCompany({});
              history.push("/company/neu");
            }}
            className={classes.button}
          >
            Neuer Kunde
          </Button>
        </div>
      </div>
      <div>
        {isCompaniesCollectionFetching ? (
          <div> Bitte Warten...</div>
        ) : (
          <div>
            {companiesDisplayList.length > 0 ? (
              <Table stickyHeader aria-label="sticky table">
                <TableHead className={classes.tableHeader}>
                  <TableRow>
                    <TableCell
                      style={{ width: "15%" }}
                      className={classes.tableHeaderCell}
                    >
                      Kundennummer
                    </TableCell>
                    <TableCell
                      style={{ width: "40%" }}
                      className={classes.tableHeaderCell}
                    >
                      Fachhändler
                    </TableCell>
                    <TableCell
                      style={{ width: "25%" }}
                      className={classes.tableHeaderCell}
                    >
                      GVL
                    </TableCell>
                    <TableCell
                      style={{ width: "25%" }}
                      className={classes.tableHeaderCell}
                    >
                      Händler-Kontakt
                    </TableCell>
                    <TableCell
                      style={{ width: "10%" }}
                      className={classes.tableHeaderCell}
                    >
                      Vertragsstatus
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {companiesDisplayList.map((company) => {
                    console.log("STATUS", company.status);
                    return (
                      <TableRow
                        className={classes.tableRow}
                        hover
                        key={company.id}
                        onClick={() => {
                          selectCompany(company);
                          history.push("/company/" + company.id);
                        }}
                      >
                        <TableCell className="loc-table-cell">
                          <Typography variant="overline">
                            {company.customer_no}
                          </Typography>
                        </TableCell>
                        <TableCell className="loc-table-cell">
                          <Typography variant="overline">
                            {company.name} {company.legal_form}
                          </Typography>
                        </TableCell>
                        <TableCell className="loc-table-cell">
                          <Typography variant="overline">
                            {company.main_sales_lead_first_name}{" "}
                            {company.main_sales_lead_last_name}
                          </Typography>
                        </TableCell>
                        <TableCell className="loc-table-cell">
                          <Typography variant="overline">
                            {company.trader_contact_first_name}{" "}
                            {company.trader_contact_last_name}
                          </Typography>
                        </TableCell>
                        <TableCell className="loc-table-cell">
                          <div className={classes.contractStatusContainer}>
                            <div className={classes.contractStatusElement}>
                              <Tooltip
                                title={getStatusDisplayValue(company.status)}
                                placement="top"
                                arrow
                              >
                                <Typography
                                  className={classes.contractStatusValue}
                                >
                                  {getContractStatusIcon(company.status)}
                                </Typography>
                              </Tooltip>
                            </div>
                          </div>
                          <div className={classes.brandStatusContainer}></div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            ) : (
              <div>Keine Ergebnisse</div>
            )}
          </div>
        )}
      </div>
    </Box>
  );
};

const mapStateToProps = createStructuredSelector({
  isCompaniesCollectionFetching: selectIsCompaniesCollectionFetching,
  companiesList: selectCompaniesCollection,
});

const mapDispatchToProps = (dispatch) => ({
  retrieveCompanies: () => dispatch(retrieveCompanies()),
  selectCompany: (company) => {
    console.log(company);
    dispatch(selectCompany(company));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CompaniesList);
